import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MassiveConfigurationsService {

  public baseURL = environment.serverApiBaseUrl;

  constructor(private readonly http: HttpClient) { }

  public getOperationTypes() {
    const url = `/${this.baseURL}/batch-process/operation-types`;
    return this.http.get(url);
  };

  public getBatchProcess() {
    const url = `/${this.baseURL}/batch-process?page=1&size=10000000`;
    return this.http.get(url);
  };

  public setBatchProcess(formData) {
    const url = `/${this.baseURL}/batch-process/upload-file`;
    return this.http.post(url, formData);
  };

  public downloadFile(data, table="download-file"){
    let url = `/${this.baseURL}/batch-process/${table}/${data.id}`;
    //window.open(url, '_blank');
    //return true;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain; charset=utf-8',
        //'Accept': '*/*'
      })
    };
    return this.http.get(url, {headers: options.headers, responseType: 'text'}).subscribe((res:any) => this.extractData(res, data.id))
    //return this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe(res => this.extractData(res))
    /*.pipe(
      map((result:HttpResponse<Blob>) => {
        console.log(result);
        //saveAs(result, "Quotation.pdf");
        return result;
      })).subscribe(res => this.extractData(res));
      */
    //.subscribe(res => {
      //console.log(res);
      //url = window.URL.createObjectURL(res);
      //window.open(url)
      //window.open(`/${this.baseURL}/batch-process/${table}/${id}`, '_blank')
    //});
  };

  public extractData(res: string, fileName: string){
    //transform response to blob
    let a = document.createElement("a");
    let myBlob: Blob = new Blob([res], {type: 'text/plain'}); // replace the type by whatever type is your response
    a.download = fileName + ".txt";

    var fileURL = URL.createObjectURL(myBlob);
    a.setAttribute('style', 'display:none;');
    a.href = fileURL;
    a.click();
  }

  public submitBatchProcess(batchProcessFileId, operationTypeId, fieldsValues) {
    const url = `/${this.baseURL}/batch-process/submit`;
    const body = {
      batchProcessFileId,
      operationTypeId,
      optionalParams: {
        sendMtOnMassConf: fieldsValues
      }
    };
    return this.http.post(url, body);
  };

  public getErrors(id) {
    const url = `/${this.baseURL}/batch-process/error-info/${id}`;
    return this.http.get(url);
  };

  public getAllMassConfigApprovals() {
    const url = `/${this.baseURL}/massConfig/search/allMassConfigApprovals`;
    return this.http.get(url);
  }

  public getAllMassConfigWaitingApproval() {
    const url = `/${this.baseURL}/massConfig/search/allMassConfigWaitingApproval`;
    return this.http.get(url);
  }
  
  public setApprove(dto) {
    const url = `/${this.baseURL}/massConfig/approve`;
    const body = {
      approvalStatus: dto.approvalStatus,
      entity: dto.entity,
      entityId: dto.entityId,
      isToSendMT: dto.isToSendMT,
      username: dto.username
    };
    return this.http.post(url, body)
  }

  public setReject(dto) {
    const url = `/${this.baseURL}/massConfig/reject`;
    const body = {
      approvalStatus: dto.approvalStatus,
      entity: dto.entity,
      entityId: dto.entityId,
      isToSendMT: dto.isToSendMT,
      username: dto.username
    };
    return this.http.post(url, body)
  }

  public setSave(dto) {
    const url = `/${this.baseURL}/massConfig/save`;
    const body = {
      approvalStatus: dto.approvalStatus,
      entity: dto.entity,
      entityId: dto.entityId,
      isToSendMT: dto.isToSendMT,
      username: dto.username
    };
    return this.http.post(url, body)
  }

  public getBatchProcessV2 = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ) => {
    const url = `/${this.baseURL}/batch-process?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
      return this.http.get(url).pipe(
        map((request: any) => {
          //item?.totalSuccesses
          request.map(data => {
            data['totalSuccesses'] ? null : data['totalSuccesses'] = 0;
            data['totalFailures'] ? null : data['totalFailures'] = 0;
            data['totalSuccessFailures'] = data['totalSuccesses'] + "/" + data['totalFailures'];
          })
          return request;
        }),
      );
  };

  public getBatchProcessCountV2 = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
    `/${this.baseURL}/batch-process/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  };

  public getAllMassConfigWaitingApprovalV2 = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any> => {
    const url =
      `/${this.baseURL}/massConfig/search/allMassConfigWaitingApproval?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<any>(url);
  };

  public getAllMassConfigWaitingApprovalCountV2 = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/massConfig/countWaitingApproval?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  };

  public getPartnersCount = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/venus-api/partner/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  };

  public tableSortOrderLogic(sortOrder) {
    return sortOrder === 1 ? (sortOrder = true) : (sortOrder = false);
  }

  public tableSortLogic(sort) {
    return (sort = sort ? '&sort=' + sort : '');
  }

  public tableGlobalFilterLogic(globalFilter) {
    return (globalFilter = globalFilter ? '&globalFilter=' + globalFilter : '');
  }

  public tableFilterLogic(myFilters) {
    if (myFilters) {
      let filters = '';
      let filterFields = Object.keys(myFilters);
      filterFields.map((filterField, i) => {
        const filterValue = myFilters[filterField]?.value
          ? myFilters[filterField].value
          : typeof myFilters[filterField] == 'string'
          ? myFilters[filterField]
          : '';

        if (filterField != 'global' && filterValue) {
          if (i == 0) {
            filters = '&' + filters + filterField + '=' + filterValue;
          } else {
            filters = filters + '&' + filterField + '=' + filterValue;
          }
        }
      });
      return (myFilters = filters);
    } else {
      return (myFilters = '');
    }
  }

}
